module.exports = "/gfw_pro_hero_video.mp4?092408";